import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["searchClient", "queryLanguages", "attributesForPrediction", "nbHits", "renderDebounceTime", "searchDebounceTime", "answersComponent"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { createClassNames } from '../core/utils';
import useAnswers from '../hooks/useAnswers';
var cx = createClassNames('Answers');
/* eslint-disable react/prop-types */

function DefaultAnswersComponent(_ref) {
  var isLoading = _ref.isLoading,
      hits = _ref.hits;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('', hits.length === 0 && '-empty')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('header')
  }), isLoading ? /*#__PURE__*/React.createElement("div", {
    className: cx('loader')
  }) : /*#__PURE__*/React.createElement("ul", {
    className: cx('list')
  }, hits.map(function (hit, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: index,
      className: cx('item')
    }, JSON.stringify(hit));
  })));
}

export default function Answers(_ref2) {
  var searchClient = _ref2.searchClient,
      queryLanguages = _ref2.queryLanguages,
      attributesForPrediction = _ref2.attributesForPrediction,
      _ref2$nbHits = _ref2.nbHits,
      nbHits = _ref2$nbHits === void 0 ? 1 : _ref2$nbHits,
      renderDebounceTime = _ref2.renderDebounceTime,
      searchDebounceTime = _ref2.searchDebounceTime,
      _ref2$answersComponen = _ref2.answersComponent,
      AnswersComponent = _ref2$answersComponen === void 0 ? DefaultAnswersComponent : _ref2$answersComponen,
      extraParameters = _objectWithoutProperties(_ref2, _excluded);

  var _useAnswers = useAnswers(_objectSpread({
    searchClient: searchClient,
    queryLanguages: queryLanguages,
    attributesForPrediction: attributesForPrediction,
    nbHits: nbHits,
    renderDebounceTime: renderDebounceTime,
    searchDebounceTime: searchDebounceTime
  }, extraParameters)),
      hits = _useAnswers.hits,
      isLoading = _useAnswers.isLoading;

  return /*#__PURE__*/React.createElement(AnswersComponent, {
    hits: hits,
    isLoading: isLoading
  });
}
/* eslint-enable react/prop-types */